import React from 'react';
import { Route, Switch } from 'react-router-dom';

import packageJson from '../package.json';
import PrivateRoute from 'components/common/shared/PrivateRoute';
import Home from 'components/home/Home';
import AllTenants from 'components/Customers/AllTenants/AllTenants';
import SentimentBoard from 'components/Interactions/SentimentBoard/SentimentBoard';
import ArrActivity from 'components/Arr/ArrActivity/ArrActivity';
import CustomerInfo from 'components/Customer/CustomerInfo/CustomerInfo';
import Settings from 'components/Settings/Settings';
import PageStatusCode from 'components/Layout/navigation/PageStatusCode/PageStatusCode';
import CohortArr from 'components/Arr/CohortArr/CohortArr';
import Notification from 'components/Layout/navigation/Notifications/NotificationPage/NotificationPage';
import Cancellations from 'components/Customers/Cancellations/Cancellations';
import Networks from 'components/Customers/Networks/Networks';
import Applications from 'components/Customers/Applications/Applications';
import SatisfactionBoard from 'components/Interactions/SatisfactionBoard/SatisfactionBoard';
import CohortChurn from 'components/Arr/CohortChurn/CohortChurn';
import RolloutCustomers from 'components/CS/AgentRollout/RolloutCustomers/RolloutCustomers';
import RolloutVersions from 'components/CS/AgentRollout/RolloutVersions/RolloutVersions';
import CloudManagementLogs from 'components/CS/CloudManagementLogs/CloudManagementLogs.tsx';
import NetworkRollout from 'components/CS/NetworkRollout/NetworkRollout.tsx';
import EdgesList from 'components/CS/EdgesList/EdgesList';
import EdgeView from 'components/CS/EdgesList/EdgeView';
import VersionsActivityLog from 'components/CS/VersionsActivityLog/VersionsActivityLog';
import Maintenance from 'components/Interactions/Maintenance/Maintenance';
import Qbrs from 'components/Interactions/Qbrs/Qbrs';
import CohortCollection from 'components/Marketing/CohortCollection/CohortCollection';
import FeaturesAdoption from 'components/Product/FeaturesAdoption/FeaturesAdoption';
import FeatureList from 'components/Product/FeaturesFlag/FeatureList/FeatureList';
import FeaturesFlagActivityLog from 'components/Product/FeaturesFlagActivityLog/FeaturesFlagActivityLog';
import AssignedCustomersRoute from 'components/Product/FeaturesFlag/AssignedCustomers/AssignedCustomersRoute';
import ActivityLogs from './components/Settings//parts/ActivityLogs/ActivityLogs';
import CopilotChat from 'components/CopilotChat/CopilotChat';
import AuthCallback from 'components/auth/AuthCallback/AuthCallback';

import Main from 'components/Mobile/Main/Main';
import Team from 'components/Mobile/Team/Team';
import { access, hasAccess, resources } from 'utils/permissions';

global.appVersion = packageJson.version;

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/auth/callback" component={AuthCallback} />
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <PrivateRoute
          exact
          path="/customers/all-tenants"
          component={AllTenants}
        />
      )}
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <PrivateRoute
          path="/customers/all-tenants/:id/:tabId"
          component={CustomerInfo}
        />
      )}

      {hasAccess([resources.RD_NETWORKS, access.READ]) && (
        <PrivateRoute exact path="/customers/networks" component={Networks} />
      )}

      <PrivateRoute
        path="/customers/networks/:id/:tabId"
        component={CustomerInfo}
      />

      {hasAccess([resources.RD_APPLICATIONS, access.READ]) && (
        <PrivateRoute
          exact
          path="/customers/applications"
          component={Applications}
        />
      )}

      <PrivateRoute
        path="/customers/applications/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess(
        [resources.CANCELLATIONS_REQUEST, access.READ],
        [resources.TENANT_SENSITIVE_DATA, access.READ]
      ) && (
        <PrivateRoute
          exact
          path="/customers/cancellations"
          component={Cancellations}
        />
      )}
      <PrivateRoute
        path="/customers/cancellations/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess(
        [resources.SATISFACTION_BOARD, access.READ],
        [resources.TENANT_SENSITIVE_DATA, access.READ]
      ) && (
        <PrivateRoute
          exact
          path="/interactions/satisfaction-board"
          component={SatisfactionBoard}
        />
      )}
      <PrivateRoute
        path="/interactions/satisfaction-board/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess([resources.QBR_BOARD, access.READ]) && (
        <PrivateRoute exact path="/interactions/qbrs-board" component={Qbrs} />
      )}
      <PrivateRoute
        path="/interactions/qbrs-board/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess([resources.RD_MAINTENANCE, access.READ]) && (
        <PrivateRoute
          exact
          path="/interactions/maintenance-windows"
          component={Maintenance}
        />
      )}
      <PrivateRoute
        path="/interactions/maintenance-windows/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess(
        [resources.SENTIMENT_BOARD, access.READ],
        [resources.TENANT_SENSITIVE_DATA, access.READ]
      ) && (
        <PrivateRoute
          exact
          path="/interactions/sentiment-board"
          component={SentimentBoard}
        />
      )}
      <PrivateRoute
        path="/interactions/sentiment-board/:id/:tabId"
        component={CustomerInfo}
      />

      {hasAccess([resources.CS_AGENT_ROLLOUT, access.READ]) && (
        <PrivateRoute
          exact
          path="/cs/agent-rollout"
          component={RolloutVersions}
        />
      )}
      {hasAccess([resources.CS_AGENT_ROLLOUT, access.READ]) && (
        <PrivateRoute
          path="/cs/agent-rollout/:platformAndId"
          component={RolloutCustomers}
        />
      )}

      {hasAccess([resources.CUSTOMERS_AGENT_LOGS, access.READ]) && (
        <PrivateRoute
          exact
          path="/cs/versions-activity-log"
          component={VersionsActivityLog}
        />
      )}
      <PrivateRoute
        path="/cs/versions-activity-log/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess([resources.CS_NETWORK_ROLLOUT, access.READ]) && (
        <PrivateRoute
          exact
          path="/cs/network-rollout"
          component={NetworkRollout}
        />
      )}
      <PrivateRoute
        path="/cs/network-rollout/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess([resources.NETWORK_EDGE, access.READ]) && (
        <PrivateRoute exact path="/cs/edges" component={EdgesList} />
      )}
      {hasAccess([resources.NETWORK_EDGE, access.READ]) && (
        <PrivateRoute path="/cs/edges/:edgeId" component={EdgeView} />
      )}
      {hasAccess([resources.CLOUD_MANAGEMENT, access.READ]) && (
        <PrivateRoute
          exact
          path="/cs/cloud-management-log"
          component={CloudManagementLogs}
        />
      )}
      {hasAccess([resources.SETTINGS_ACTIVITY_LOG, access.READ]) && (
        <PrivateRoute exact path="/cs/activity-log" component={ActivityLogs} />
      )}
      <PrivateRoute
        path="/cs/cloud-management-log/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess([resources.PRODUCT_FEATURE_FLAG, access.READ]) && (
        <PrivateRoute
          exact
          path="/product/feature-flag"
          component={FeatureList}
        />
      )}
      {hasAccess([resources.PRODUCT_FEATURE_FLAG, access.WRITE]) && (
        <PrivateRoute
          path="/product/feature-flag/:featureId"
          component={AssignedCustomersRoute}
        />
      )}

      {hasAccess([resources.PRODUCT_FEATURE_FLAG_LOGS, access.READ]) && (
        <PrivateRoute
          exact
          path="/product/ff-activity-log"
          component={FeaturesFlagActivityLog}
        />
      )}
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <PrivateRoute
          exact
          path="/product/features-adoption"
          component={FeaturesAdoption}
        />
      )}

      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <PrivateRoute
          path="/product/features-adoption/:id/:tabId"
          component={CustomerInfo}
        />
      )}
      {hasAccess(
        [resources.MRR_ACTIVITY, access.READ],
        [resources.TENANT_SENSITIVE_DATA, access.READ]
      ) && (
        <PrivateRoute exact path="/arr/arr-activity" component={ArrActivity} />
      )}
      <PrivateRoute
        path="/arr/arr-activity/:id/:tabId"
        component={CustomerInfo}
      />
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <PrivateRoute exact path="/arr/arr-cohort" component={CohortArr} />
      )}
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <PrivateRoute exact path="/arr/churn-cohort" component={CohortChurn} />
      )}
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <PrivateRoute
          exact
          path="/marketing/collection-cohort"
          component={CohortCollection}
        />
      )}

      {hasAccess([resources.COPILOT_CHAT, access.READ]) && (
        <PrivateRoute exact path="/copilot-chat" component={CopilotChat} />
      )}

      {hasAccess([resources.SETTINGS_USERS, access.READ]) && (
        <PrivateRoute exact path="/settings/:tabs" component={Settings} />
      )}
      <PrivateRoute exact path="/notifications" component={Notification} />
      <PrivateRoute exact path="/mobile/main" component={Main} />
      <PrivateRoute path="/mobile/team/:id" component={Team} />
      <Route
        path="/forbidden"
        component={props => <PageStatusCode {...props} statusCode="403" />}
      />
      <Route
        path="/invalid-region"
        render={props => <PageStatusCode {...props} statusCode="404" />}
      />
      <Route
        component={props => <PageStatusCode {...props} statusCode="404" />}
      />
    </Switch>
  );
};

export default Routes;
